/* @flow */

import { rem } from 'polished';
import { tablet } from '@e180/ui/lib/token/mediaQuery';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: [rem(8, baseFontSize), rem(16, baseFontSize)],
    width: '100%',

    '& > *': {
      marginTop: '16px',
    },

    [tablet]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
    },
  },
};
